'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'icons';
var width = 576;
var height = 512;
var aliases = ["heart-music-camera-bolt"];
var unicode = 'f86d';
var svgPathData = ['M32 67c0-37 30-67 67-67 21.1 0 41 9.9 53.6 26.8l7.3 9.8 7.3-9.8C180 9.9 199.8 0 221 0 258 0 288 30 288 67l0 6.1c0 73.1-128 146.3-128 146.3S32 146.3 32 73.1L32 67zM344 400l184-160-57.6 128 81.6 0-184 160 57.6-128-81.6 0z', 'M336 96.9l0 80.6c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48l0-110.1 112-33.6 0 49.2c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48l0-127.1c0-.6 0-1.2 0-1.8l0-55.3-30.9 9.2-160 48-17.1 5.2 0 40.9c0 .6 0 1.2 0 1.8zM128 272l-21.3 32-74.7 0 0 208 288 0 0-208-74.7 0-21.3-32-96 0zm48 88a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIcons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;